import styled, { css } from 'styled-components';
import { getTypographyStyles, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_50, SEM_TYPOGRAPHY_FEEDBACK_BADGE_INFO, SEM_TYPOGRAPHY_FEEDBACK_LABEL, SYS_SIZE_FIXED_600, SYS_BORDER_RADIUS_MAX, getMargins } from '@oneaudi/unified-web-alpha-common';
export const StyledBadge = styled.div `
  flex-shrink: 0;
  margin: ${(props) => getMargins(props.margin)};

  ${(props) => {
    if (props.count || props.alert) {
        return css `
        display: inline-flex;
        box-sizing: border-box;
        align-items: center;
        justify-content: center;
        border-radius: ${SYS_BORDER_RADIUS_MAX};
        min-width: ${SYS_SIZE_FIXED_600};
        width: auto;
        height: ${SYS_SIZE_FIXED_600};
        padding: ${SYS_SPACE_FIXED_50};
        background-color: ${props.theme.sem.color.feedback.surface.informative};
        color: ${props.theme.sem.color.feedback.foreground.text.inverted};
        ${getTypographyStyles(SEM_TYPOGRAPHY_FEEDBACK_BADGE_INFO)}
      `;
    }
    if (props.semanticShape === 'informative') {
        return css `
        width: ${SYS_SPACE_FIXED_100};
        height: ${SYS_SPACE_FIXED_100};
        border-radius: 100%;
        background-color: ${props.theme.sem.color.feedback.surface.informative};
      `;
    }
    if (props.semanticShape === 'negative') {
        return css `
        position: relative;
        width: ${SYS_SPACE_FIXED_100};
        height: ${SYS_SPACE_FIXED_100};

        &::before {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          content: '';
          width: 0px;
          height: 0px;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-bottom: 9px solid
            ${props.theme.sem.color.feedback.surface.error};
        }
      `;
    }
    if (props.semanticShape === 'notice') {
        return css `
        width: ${SYS_SPACE_FIXED_100};
        height: ${SYS_SPACE_FIXED_100};
        clip-path: polygon(50% 0, 100% 50%, 50% 100%, 0 50%);
        background-color: ${props.theme.sem.color.feedback.surface.notice};
      `;
    }
    return css `
      border-radius: 100%;
      width: ${SYS_SPACE_FIXED_100};
      height: ${SYS_SPACE_FIXED_100};
      background-color: ${props.theme.sem.color.feedback.surface.success};
    `;
}}
`;
export const StyledContainer = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  display: flex;
  align-items: center;
  gap: ${SYS_SPACE_FIXED_100};
  color: ${(props) => props.theme.sem.color.feedback.foreground.text.informative};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FEEDBACK_LABEL)}
`;
//# sourceMappingURL=index.styles.js.map